import _regenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _slicedToArray from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import Create from './create';
export default {
  name: "history",
  data: function data() {
    return {
      dataList: [],
      template: null
    };
  },
  methods: {
    cancel: function cancel() {
      this.$emit('cancel');
    },
    create: function create() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _yield$_this$$awaitTo, _yield$_this$$awaitTo2, err, data;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return _this.$awaitTo(_this.$dialog(Create, {
                dialog: {
                  appendToBody: true,
                  modalAppendToBody: true,
                  title: '新增'
                },
                props: {}
              }, function (template) {
                _this.template = template;
              }));
            case 1:
              _yield$_this$$awaitTo = _context.v;
              _yield$_this$$awaitTo2 = _slicedToArray(_yield$_this$$awaitTo, 2);
              err = _yield$_this$$awaitTo2[0];
              data = _yield$_this$$awaitTo2[1];
              _this.template = null;
              if (!err) {
                _context.n = 2;
                break;
              }
              return _context.a(2);
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    }
  }
};